Vue.component('ops-settings', {
    data () {
        return {
            settings: null,

            loading: false
        }
    },

    mounted () {
        $('#ops-settings').on('shown.bs.modal', this.fetchSettings);
    },

    methods: {
        fetchSettings () {
            this.loading = true;

            axios.get('/api/ops-settings')
                .then((res) => {
                    this.settings = res.data;
                    this.loading = false;
                });
        },

        handleSubmit () {
            this.loading = true;

            axios.post('/api/ops-settings/save', {
                settings: this.settings
            })
                .then(() => {
                    $('#ops-settings').modal('hide');
                    this.loading = false;
                });
        }
    }
});
